import "@fontsource-variable/geist";
import "@fontsource-variable/noto-sans-sc";
import "@fontsource-variable/roboto";
import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { App } from "./App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 20_000, retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: 0 },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename="/mail">
        <App />
        <Toaster richColors position="bottom-left" />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
